import { useState } from 'react'
import Image from 'next/image'
import cx from 'classnames'
import { useTranslation } from 'next-i18next'
import { QueryStatus } from 'react-query'

import CarouselModal from '../CarouselModal'

import { Listing, PhotoResolutions } from '../../services/getListings'

import { LockIcon } from 'icons'

const Gallery = ({
  listing,
  photos,
  fullListingStatus,
}: {
  listing: Listing | null
  photos: PhotoResolutions[]
  fullListingStatus: QueryStatus
}) => {
  const { t } = useTranslation(['homes', 'common'])
  const [showCarousel, setShowCarousel] = useState(false)
  const [initialCarouselIndex, setInitialCarouselIndex] = useState(0)

  return (
    <>
      <div
        className={cx(
          'grid gap-16 p-16',
          'lg:auto-rows-[minmax(213px,auto)] lg:grid-cols-2',
          'lg-d:grid-col lg-d:auto-cols-[350px] lg-d:grid-flow-col lg-d:auto-rows-[233px]'
        )}
      >
        {!listing?.thumbnail_resolutions ? (
          <div
            className={cx(
              'relative overflow-hidden rounded-sm lg:col-span-2 lg:row-span-1 lg:h-[389px]',
              {
                'before:absolute before:inset-0 before:z-10 before:bg-grey-2 after:absolute after:inset-0 after:z-20 after:animate-pulse after:bg-grey-4':
                  fullListingStatus !== 'success',
              }
            )}
          >
            <Image
              src="/app-assets/listing-card-default.jpg"
              alt=""
              layout="fill"
              objectFit="cover"
            />
          </div>
        ) : (
          <button
            onClick={() => {
              setShowCarousel(true)
              setInitialCarouselIndex(0)
            }}
            className="relative overflow-hidden rounded-sm lg:col-span-2 lg:row-span-1 lg:h-[389px]"
          >
            {listing?.existing_offer ? (
              <div className="absolute left-16 top-16 z-50 flex items-center rounded-md bg-gold-1 px-16 py-10">
                <LockIcon
                  aria-hidden="true"
                  className="mr-10 flex-shrink-0 stroke-grey-8 rect-14"
                />
                <span className="font-sans text-12 font-bold uppercase">
                  {t('offer-pending-label', { ns: 'common' })}
                </span>
              </div>
            ) : null}
            {/* {listing?.acre_sold ? (
              <div className="absolute top-16 left-16 z-50 flex items-center rounded-lg bg-white px-16 py-10">
                <AcreMiniLogoIcon
                  className="fill-tan-3 rect-12"
                  aria-hidden="true"
                />
                <span className="ml-10 font-sans text-12 font-bold uppercase">
                  {t('ui.sold', { ns: 'common' })}
                </span>
              </div>
            ) : null} */}
            <Image
              src={listing?.thumbnail_resolutions.high}
              alt=""
              layout="fill"
              objectFit="cover"
            />
          </button>
        )}

        {photos.map((photo: PhotoResolutions, i: number) => {
          if (i === 0) {
            return null
          }

          return (
            <button
              onClick={() => {
                setShowCarousel(true)
                setInitialCarouselIndex(i)
              }}
              key={i}
              className="relative overflow-hidden rounded-sm bg-grey-8/10"
            >
              <Image
                src={photo.low}
                quality={100}
                alt=""
                layout="fill"
                objectFit="cover"
              />
            </button>
          )
        })}
      </div>
      <CarouselModal
        images={photos}
        isOpen={showCarousel}
        initialIndex={initialCarouselIndex}
        handleClose={() => setShowCarousel(false)}
        srHeading={t('imageCarouselModalLabel')}
      />
    </>
  )
}

export default Gallery
